export default "__VITE_ASSET__CsbNzRDA__"